import bundleService from '../../../../services/bundles/bundle-service';

type FetchBundlesSuggestedProps = { bundleIds: number[] };

// e.g., Bundles need to fetch: (456 and 786)
// Request: `?ids=456,786&limit=2&filterByWorld=1`
// Response: Material[]
const fetchBundlesSuggested = async ({ bundleIds }: FetchBundlesSuggestedProps): Promise<Material[]> => {
    const response = await bundleService.getBundlesSuggested({
        ids: bundleIds.join(','),
        limit: bundleIds.length,
        filterByWorld: 1
    });

    return response?.data?.items ?? [];
};

export default fetchBundlesSuggested;
